var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseCell,{attrs:{"align":_vm.align}},[_c(_setup.BaseText,{attrs:{"size":"xs","color":_setup.percentualColor}},[_c(_setup.component,{tag:"component",staticClass:"money-cell",attrs:{"width":`calc( ${_vm.width} * 0.75)`,"border-radius":_vm.borderRadius}},[_vm._v(" "+_vm._s(_vm.percentualFormatted)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }